import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinnerThird } from "@fortawesome/pro-duotone-svg-icons";
import '../App.scss';
/*import TagManager from 'react-gtm-module';*/
import { enableQuestionsInSet } from '../functions/QuestionEnabling';
import { tracking } from '../functions/Tracking';
import { Action } from '../enums/TrackingActionType';
import { GetTradeByName } from '../functions/Trades';
import { sendQuoteEmail } from '../functions/Email';
import { getErrorLogIdFromResponse } from '../functions/ErrorLogging';
import { getOpeningHours } from '../functions/OperatingHours';
import { isShortJourney } from '../functions/JourneyLength';
import { IsWebReference, IsWebReferenceSuffix } from '../functions/Configuration';
import { sortNumericAnswers } from '../functions/AnswerListSorting';

//const tagManagerArgs = {
//    dataLayer: {
//        userId: '001',
//        userProject: 'CAQWeb',
//        page: 'loading'
//    },
//    dataLayerName: 'LoadingPageDataLayer'
//}
export default function Loading(props: any) {

    var getUrlParameter = (name: string) =>
        new URLSearchParams(window.location.search).get(name) ?? ""

    let navigate = useNavigate();
    const location = useLocation();
    const [questions, setQuestions] = useState<any[]>([]);
    const [quotes, setQuotes] = useState<any>(null);
    const [trade, setTrade] = useState<any>({});
    const [status, setStatus] = useState<any>("");
    const [customerDetails, setCustomerDetails] = useState<any>({});
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const [readyToNavigate, setReadyToNavigate] = useState(false);
    const [readyToSubmitAnswers, setReadyToSubmitAnswers] = useState(false);
    const [readyToCreateCustomer, setReadyToCreateCustomer] = useState(false);
    const [readyToGetQuestionSet, setReadyToGetQuestionSet] = useState(false);
    const openingHours = getOpeningHours();
    const config = JSON.parse(localStorage.getItem('siteConfig') || "{}");

    const standardHours = openingHours.Monday.open + " - " + openingHours.Thursday.close;
    const fridayHours = openingHours.Friday.open + " - " + openingHours.Friday.close;

    let getQuestionsAttempts = 0;
    let saveAnswerAttempts = 0;

    /*TagManager.dataLayer(tagManagerArgs)*/

    useEffect(() => {
        props.setCurrentPage(0);
        props.setSidebarVisibility(false);
        delayedNavigation();
    }, [])

    useEffect(() => {
        if (readyToNavigate) {
            nextNavigation();
        }
    }, [readyToNavigate])


    useEffect(() => {
        if (readyToSubmitAnswers) {
            saveAnswers();
        }
    }, [readyToSubmitAnswers])

    useEffect(() => {
        if (readyToCreateCustomer) {
            checkExistsAndCreateInitialPolicy();
        }
    }, [readyToCreateCustomer])

    useEffect(() => {
        if (readyToGetQuestionSet) {
            getQuestionSet();
        }
    }, [readyToGetQuestionSet])

    const delayedNavigation = () => {
        fetch(location.state)
            .then((response) => {
                //let urlParams = new URLSearchParams(window.location.search);
                if (getUrlParameter("signature") !== "") {
                    var realexSuccessful = getUrlParameter("success");
                    if (realexSuccessful === "true") {
                        RealexCompleted();
                    } else {
                        navigate("/Payment", {
                            state: {
                                paymentFailed: true
                            }
                        });
                    }
                }

                if (getUrlParameter("policyNumber") !== "") {
                    localStorage.setItem("gclid", getUrlParameter("gclid"));
                    if (IsWebReferenceSuffix(getUrlParameter("webReference"), "PO") && getUrlParameter("action") !== "amend")
                    {
                        getDetailsForPOQuote();
                    } else {
                        getDetailsForQuote();
                    }
                }

                const renewalPolicyNumber = getUrlParameter("renewalPolicyNumber");

                if (renewalPolicyNumber !== "") {
                    const historyID = getUrlParameter("renewalPolicyHID");
                    const success = getUrlParameter("success");
                    const message = getUrlParameter("message");
                    if (success === "true") {
                        navigate("/Completed");
                        return;
                    }

                    displayPolicyRenewal(renewalPolicyNumber, historyID, success === "false" ? message : "");
                }

                if (location.state != null) {
                    if (location.state.pageToLoad === "/YourQuotes") {

                        setQuestions(JSON.parse(localStorage.getItem('questions') || ""));

                        setCustomerDetails(JSON.parse(localStorage.getItem('customerDetails') || ""));
                        setReadyToSubmitAnswers(true);
                    }
                    if (location.state.pageToLoad === "/YourBusiness") {
                        setCustomerDetails(JSON.parse(localStorage.getItem('customerDetails') || ""));
                        setTrade(JSON.parse(localStorage.getItem('trade') || ""));
                        setStatus(localStorage.getItem('status'));
                        setReadyToCreateCustomer(true);
                    }
                }

            })
            .catch((error) => {
                console.error('An error occurred:', error);
            });
    }

    const saveAnswers = () => {
        saveAnswerAttempts = saveAnswerAttempts + 1;
        var answeredQuestions = questions.map(question => {
            question.answer = question.answer.toString();

            if (question.questionSetQuestion.visible === "1" || question.questionSetQuestion.visible === 1 || question.questionSetQuestion.visible === true) {
                question.questionSetQuestion.visible = true;
            } else {
                question.questionSetQuestion.visible = false;
            }

            if (question.validationFail === "") {
                question.validationFail = false
            }

            if (typeof question.validationFail === 'string') {
                question.validationFail = question.validationFail = "true" ? true : false;
            }

            if (question.childInformation != null) {
                const newChildren = question.childInformation.map((childQuestion: any) => {
                    if (childQuestion.questionSetQuestion.visible === "1" || childQuestion.questionSetQuestion.visible === 1) {
                        childQuestion.questionSetQuestion.visible = true;
                    } else {
                        childQuestion.questionSetQuestion.visible = false;
                    }

                    if (childQuestion.validationFail === "1" || childQuestion.validationFail === 1) {
                        childQuestion.validationFail = true;
                    } else {
                        childQuestion.validationFail = false;
                    }

                    if (typeof childQuestion.validationFail === 'string') {
                        childQuestion.validationFail = childQuestion.validationFail = "true" ? true : false;
                    }

                    return childQuestion;
                });
                question.childInformation = newChildren;
            }

            return question;
        });

        let tradeDescription = null;

        if (!IsWebReference("PO") && localStorage.getItem('trade') != null) {
            let storedTrade = JSON.parse(localStorage.getItem('trade') || "");
            tradeDescription = storedTrade.description;
        }

        fetch(`${apiBaseUrl}question/SubmitAnswers`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json, text/plain',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify({ customerDetails: customerDetails, answeredQuestionSet: answeredQuestions, trade: tradeDescription })
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data.success) {
                    localStorage.setItem('quotes', JSON.stringify(JSON.parse(data.object)));
                    setQuotes(JSON.parse(data.object));
                    setReadyToNavigate(true);
                } else {
                    // attempt to call the api 3 times before going to the error screen
                    if (saveAnswerAttempts < 4) {
                        saveAnswers();
                    } else {
                        localStorage.setItem("errorLogId", data.message);
                        navigate('/Error');
                    }
                }
            }).catch((error) => {
                if (saveAnswerAttempts < 4) {
                    saveAnswers();
                } else {
                    let errorLogId = getErrorLogIdFromResponse(error);
                    localStorage.setItem("errorLogId", errorLogId);
                    navigate('/Error');
                }
            });
    }

    async function nextNavigation() {
        // Load requested page
        if (location.state) {
            if (quotes != null && location.state.pageToLoad === '/YourQuotes') {
                if (quotes.length > 0) {
                    tracking(Action.SAVE_QUOTE);
                    if (!IsWebReferenceSuffix(localStorage.getItem('webReference') || "", "PO")) {
                        sendQuoteEmail();
                    }
                    navigate(location.state.pageToLoad);
                } else {
                    tracking(Action.SAVE_NO_QUOTE);
                    navigate('/NoQuotes');
                }
            } else {
                navigate(location.state.pageToLoad);
            }
            
            // Load error page if bad request.
        } else {
            //Clicking Buy on YourQuotes page;
            if (getUrlParameter("policyNumber") !== "") {
                if (quotes?.length > 0) {
                    navigate('/YourQuotes');
                } else {
                    navigate('/NoQuotes');
                }
            } else {
                navigate("/Error", {
                    state: {
                        errorTitle: "Error",
                        errorMessage: "Page not found",
                    },
                });
            }
        }
    }

    const checkExistsAndCreateInitialPolicy = () => {
        let newCustomerDetails = customerDetails;
        if (newCustomerDetails.webReference === null) {
            newCustomerDetails.webReference = trade.webBranding;
        }

        newCustomerDetails.agentID = config.agentID;
        newCustomerDetails.campaignID = 'WEBCAM01';
        newCustomerDetails.sourceOfBusinessID = config.sourceOfBusinessId;

        if (status === "trader") {
            newCustomerDetails.isCompany = false;
        } else {
            newCustomerDetails.isCompany = true;
            newCustomerDetails.title = "0";
            newCustomerDetails.forename = "";
        }

        fetch(`${apiBaseUrl}customer/CheckExistsAndCreateInitialPolicy`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json, text/plain',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify(newCustomerDetails)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data.success) {

                    var customerInfo = JSON.parse(data.object);
                    if (customerInfo.hasOwnProperty('extensionData')) {
                        delete customerInfo.extensionData;
                    }
                    if (customerInfo.address.hasOwnProperty('extensionData')) {
                        delete customerInfo.address.extensionData;
                    }
                    if (customerInfo.contactPreferences != null) {
                        if (customerInfo.contactPreferences.hasOwnProperty('extensionData')) {
                            delete customerInfo.contactPreferences.extensionData;
                        }
                    }
                    localStorage.setItem('customerDetails', JSON.stringify(customerInfo));
                    localStorage.setItem('webReference', customerInfo.webReference);
                    localStorage.setItem('shortJourney', isShortJourney(customerInfo.webReference));
                    setCustomerDetails(customerInfo);
                    addDeviceDetection(customerInfo);
                    tracking(Action.SAVE_QUESTIONS);
                } else {
                    localStorage.setItem("errorLogId", data.message);
                    navigate('/Error');
                }
            }).catch((error) => {
                let errorLogId = getErrorLogIdFromResponse(error);
                localStorage.setItem("errorLogId", errorLogId);
                navigate('/Error');
            });
    }

    const addDeviceDetection = (customerInfo: any) => {

        let isMobileParam = false;
        if (localStorage.getItem('isMobile') === "true") {
            isMobileParam = true;
        }

        fetch(`${apiBaseUrl}customer/AddDeviceDetection`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json, text/plain',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify({ customerDetails: customerInfo, browserType: localStorage.getItem('browserType'), deviceType: localStorage.getItem('deviceType'), isMobile: isMobileParam, trade: trade.description })
        })
            .then(response => {
                return response.json();
            }).then(data => {
                if (data.success) {
                    localStorage.setItem('deviceDetectionID', data.object);
                }
                setReadyToGetQuestionSet(true);
            })
            .catch((error) => {

            });
    }

    const getQuestionSet = () => {
        getQuestionsAttempts = getQuestionsAttempts + 1;
        fetch(`${apiBaseUrl}question/GetQuestionSet`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json, text/plain',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify(customerDetails)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data.success) {
                    let returnedQuestions = JSON.parse(data.object);
                    let tradeQuestionID = 0;
                    let statusQuestionID = 0;
                    const assumptions: string[] = [];
                    returnedQuestions.map((question: any) => {
                        if (trade !== "") {
                            if (question.questionSetQuestion.text.toLowerCase() === "what is your main trade?" && trade.keywords !== "customadded") {
                                if (question.answerList.find((x: { text: string; }) => x.text.toLocaleLowerCase() === trade.description.toLocaleLowerCase()) !== undefined) {
                                    let selectedTradeAnswer = question.answerList.find((x: { text: string; }) => x.text.toLocaleLowerCase() === trade.description.toLocaleLowerCase()).value;
                                    question.answer = selectedTradeAnswer;
                                    tradeQuestionID = question.questionSetQuestion.questionID;
                                } else {
                                    question.answer = '';
                                    var updatedTrade = trade;
                                    updatedTrade.keywords = "customadded";
                                    localStorage.setItem('trade', JSON.stringify(updatedTrade));
                                }
                            }

                            if (question.questionSetQuestion.text.toLowerCase() === "what is your main trade?" && trade.keywords === "customadded") {
                                question.answer = '';
                            }
                        }

                        if (question.questionSetQuestion.text.toLowerCase() === "what is your company status?") {
                            let statusText = "";
                            if (status === "limited") {
                                statusText = "Limited";
                            }

                            if (status === "partner") {
                                statusText = "Partnership";
                            }

                            if (status === "trader") {
                                statusText = "Individual Trading As";
                            }

                            let selectedStatusAnswer = question.answerList.filter((x: { text: string; }) => x.text.toLocaleLowerCase() === statusText.toLocaleLowerCase())[0].value;
                            question.answer = selectedStatusAnswer;
                            statusQuestionID = question.questionSetQuestion.questionID;
                        }

                        if (question.sectionName.toLowerCase().includes("assumptions") && question.questionSetQuestion.enabled === true) {
                            assumptions.push(question.questionSetQuestion.text);
                        }
                        return question;
                    });
                    // enable questions based on trade selected
                    if (trade.keywords !== "customadded") {
                        returnedQuestions = enableQuestionsInSet(returnedQuestions, tradeQuestionID);
                    }
                    // enable questions based on company status selected
                    returnedQuestions = enableQuestionsInSet(returnedQuestions, statusQuestionID);

                    // Sort numerical answerlist into numerical order by answer list text
                    if (IsWebReferenceSuffix(localStorage.getItem("webReference") || "", "RPO")) {
                        returnedQuestions = sortNumericAnswers(returnedQuestions);
                    };

                    // store all the assumption question text for use when the policy is converted
                    localStorage.setItem('assumptions', JSON.stringify(assumptions));
                    localStorage.setItem('trade', JSON.stringify(trade));
                    localStorage.setItem('status', status);
                    localStorage.setItem('customerDetails', JSON.stringify(customerDetails));
                    localStorage.setItem('questions', JSON.stringify(returnedQuestions));

                    setQuestions(returnedQuestions);
                    setReadyToNavigate(true);
                } else {
                    if (getQuestionsAttempts < 4) {
                        getQuestionSet();
                    } else {
                        localStorage.setItem("errorLogId", data.message);
                        navigate('/Error');
                    }

                }
            }).catch((error) => {
                let errorLogId = getErrorLogIdFromResponse(error);
                localStorage.setItem("errorLogId", errorLogId);
                navigate('/Error');
            });
    }

    // Begin RealexCompleted
    const RealexCompleted = () => {
        let customerDetails = JSON.parse(localStorage.getItem('customerDetails') || "");
        let cardID = localStorage.getItem('realexCardID');

        // Fetch with query string
        fetch(`${apiBaseUrl}quote/RealexCompleted?success=${getUrlParameter("success")}&signature=${getUrlParameter("signature")}
        &authcode=${getUrlParameter("authcode")}&eftreference=${getUrlParameter("eftreference")}&hash=${getUrlParameter("hash")}
        &realexCardID=${cardID}&realexOrderID=${customerDetails.policyDetailsID}`, {
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                let responseData = JSON.parse(data.object);
                if (data.success) {
                    ConvertPolicy(responseData.realexPayment);
                } else {
                    localStorage.setItem("errorLogId", data.message);
                    navigate('/Error');
                }
            }).catch((error) => {
                let errorLogId = getErrorLogIdFromResponse(error);
                localStorage.setItem("errorLogId", errorLogId);
                navigate('/Error');
            });
    }

    // Begin ConvertPolicy
    const ConvertPolicy = (realexPayment: any) => {
        // Get local storage data & remove extension data
        let customerDetails = JSON.parse(localStorage.getItem('customerDetails') || "");
        let selectedQuote = JSON.parse(localStorage.getItem('selectedQuote') || "");
        if (selectedQuote.schemeContent.hasOwnProperty('extensionData')) {
            delete selectedQuote.schemeContent.extensionData;
        }
        let paymentDetails = JSON.parse(localStorage.getItem('paymentDetails') || "");
        let payAnnual = localStorage.getItem('payAnnual') === "true";
        let assumptionsList = JSON.parse(localStorage.getItem('assumptions') || "");
        if (paymentDetails.hasOwnProperty('extensionData')) {
            delete paymentDetails.extensionData;
        }
        if (realexPayment.hasOwnProperty('extensionData')) {
            delete realexPayment.extensionData;
        }

        // Convert Policy request call
        fetch(`${apiBaseUrl}quote/ConvertPolicy`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json, text/plain',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify({ customerDetails: customerDetails, quoteResult: selectedQuote, paymentDetails: paymentDetails, payAnnual: payAnnual, realexPayment: realexPayment, assumptionsList: assumptionsList })
        })
            .then(response => {
                return response.json();
            }).then(data => {
                if (data.success) {
                    localStorage.setItem("policyRef", data.object);

                    tracking(Action.SAVE_PURCHASE);
                    navigate('/Completed'); // Navigate to completed page
                } else {
                    localStorage.setItem("errorLogId", data.message);
                    tracking(Action.SAVE_PURCHASE_ERROR);
                    navigate('/Error');
                }
            })
            .catch((error) => {
                let errorLogId = getErrorLogIdFromResponse(error);
                localStorage.setItem("errorLogId", errorLogId);
                tracking(Action.SAVE_PURCHASE_ERROR);
                navigate('/Error'); // Navigate to error page
            });
    }

    const getDetailsForPOQuote = () => {

        localStorage.setItem('shortJourney', "true");

        fetch(`${apiBaseUrl}quote/GetPOQuotes?policyDetailsID=${getUrlParameter("policyDetailsID")}&policyDetailsHID=${getUrlParameter("policyDetailsHID")}
        &productID=${getUrlParameter("productID")}&productType=${getUrlParameter("productType")}&agentID=${getUrlParameter("agentID")}
        &email=${getUrlParameter("email")}&policyNumber=${getUrlParameter("policyNumber")}&webReference=${getUrlParameter("webReference")}`, {
        })
            .then(response => {
                return response.json();
            }).then(data => {
                if (data.success) {
                    let result = JSON.parse(data.object);
                    localStorage.setItem("customerDetails", JSON.stringify(result.customerDetails));
                    localStorage.setItem("quotes", JSON.stringify(result.quotes));
                    localStorage.setItem("assumptions", JSON.stringify(result.assumptions));
                    if (result.quotes.length > 0) {
                        navigate('/YourQuotes');
                    } else {
                        navigate('/NoQuotes');
                    }
                    
                } else {
                    localStorage.setItem("errorLogId", data.message);
                    tracking(Action.SAVE_PURCHASE_ERROR);
                    navigate('/Error');
                }
            })
            .catch((error) => {
                let errorLogId = getErrorLogIdFromResponse(error);
                localStorage.setItem("errorLogId", errorLogId);
                tracking(Action.SAVE_PURCHASE_ERROR);
                navigate('/Error'); // Navigate to error page
            });
    }

    const getDetailsForQuote = () => {
        let status = getUrlParameter("type");
        localStorage.setItem('status', status ? status : "");
        let tradeName = getUrlParameter("trade");

        if (tradeName !== "") {
            let tradeObject = GetTradeByName(tradeName);
            setTrade(tradeObject);
            localStorage.setItem('trade', JSON.stringify(tradeObject));
        }

        localStorage.setItem('shortJourney', isShortJourney(getUrlParameter("webReference")));

        // Fetch with query string
        fetch(`${apiBaseUrl}question/RetrieveDetailsForQuote?policyDetailsID=${getUrlParameter("policyDetailsID")}&policyDetailsHID=${getUrlParameter("policyDetailsHID")}
        &productID=${getUrlParameter("productID")}&productType=${getUrlParameter("productType")}&agentID=${getUrlParameter("agentID")}
        &email=${getUrlParameter("email")}&policyNumber=${getUrlParameter("policyNumber")}&webReference=${getUrlParameter("webReference")}`, {
        })
            .then(response => {
                return response.json();

            })
            .then(data => {
                if (data.success) {
                    var returnedData = JSON.parse(data.object);
                    var customerInfo = returnedData.customerDetails;
                    if (customerInfo.hasOwnProperty('extensionData')) {
                        delete customerInfo.extensionData;
                    }
                    if (customerInfo.address.hasOwnProperty('extensionData')) {
                        delete customerInfo.address.extensionData;
                    }
                    if (returnedData.contactPreferences != null) {
                        if (customerInfo.contactPreferences.hasOwnProperty('extensionData')) {
                            delete customerInfo.contactPreferences.extensionData;
                        }
                    }
                    if (getUrlParameter("incomplete") === "" && window.location.href.includes("Loading")) {

                        if (tradeName === null || tradeName === "") {
                            returnedData.questionSet.map((question: any) => {
                                if (question.questionSetQuestion.text.toLowerCase() === "what is your main trade?") {
                                    let selectedTradeAnswer = question.answerList.find((x: { value: string; }) => x.value === question.answer).text;
                                    let tradeObject = { "description": selectedTradeAnswer, "keywords": "", "priority": "1000", "products": localStorage.getItem("webReference"), "webBranding": localStorage.getItem("webReference") };
                                    localStorage.setItem("trade", JSON.stringify(tradeObject));
                                }
                            });
                        }
                        if (status === null || status === "") {

                            returnedData.questionSet.map((question: any) => {
                                if (question.questionSetQuestion.text.toLowerCase() === "what is your company status?") {
                                    let selectedStatusAnswer = question.answerList.find((x: { value: string; }) => x.value === question.answer).text;

                                    if (selectedStatusAnswer === "Limited") {
                                        selectedStatusAnswer = "limited";
                                    }

                                    if (selectedStatusAnswer === "Partnership") {
                                        selectedStatusAnswer = "partner";
                                    }

                                    if (selectedStatusAnswer === "Individual Trading As") {
                                        selectedStatusAnswer = "trader";
                                    }
                                    localStorage.setItem("status", selectedStatusAnswer);
                                }
                            });
                        }
                    }

                    localStorage.setItem('customerDetails', JSON.stringify(customerInfo));
                    localStorage.setItem('questions', JSON.stringify(returnedData.questionSet));
                    localStorage.setItem("assumptions", JSON.stringify(returnedData.assumptions));

                    if (getUrlParameter("webReference")) {
                        localStorage.setItem("webReference", getUrlParameter("webReference"));
                    }

                    if (getUrlParameter("action") === "amend") {
                        if (getUrlParameter("incomplete") === "") {
                            navigate('/YourBusiness');
                        } else {
                            navigate('/IncompleteQuote');
                        }
                    } else {
                        tracking(Action.SAVE_EMAIL);
                        setCustomerDetails(customerInfo);
                        setQuestions(returnedData.questionSet);
                        setReadyToSubmitAnswers(true);
                    }

                } else {
                    localStorage.setItem("errorLogId", data.message);
                    navigate('/Error');
                }
            }).catch((error) => {
                let errorLogId = getErrorLogIdFromResponse(error);
                localStorage.setItem("errorLogId", errorLogId);
                navigate('/Error');
            });
    }

    const displayPolicyRenewal = (policyNumber: string, historyID: string, message: string = "") => {
        const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData') as string) : null;
        fetch(`${apiBaseUrl}admin/GetRenewalDetails?policyNumber=${policyNumber}&policyHistoryId=${historyID}`, {
            headers: {
                'Authorization': `Bearer ${userData.token}`,
                'Accept': 'application/json'
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                localStorage.setItem('renewal', JSON.stringify(JSON.parse(data.object)));
                navigate("/YourRenewal", {
                    state: {
                        paymentError: message
                    },
                });
            }).catch((error) => {

            });
    }

    return (
        <div className="notification-container">
            <span>
                {/* Loading title and message */}
                {location.state ? (
                    <>
                        {/* Customised loading title and message */}
                        <p className="notification-title">{location.state.loadingTitle}</p>
                        <p className="notification-message">{location.state.loadingMessage}</p>
                    </>
                ) : (
                    <>
                        {/* Default title and message */}
                        <p className="notification-title">{props.loadingTitle}</p>
                        <p className="notification-message">{props.loadingMessage}</p>
                    </>
                )}
                {/*Loading spinner*/}
                <div className="notification-message">
                    <FontAwesomeIcon className="loading-spinner" icon={faSpinnerThird} spin />
                </div>

                {/*If there are any issues contact us */}
                <p>If there are any issues while loading this page. Please call us on {config.phoneNumber}. <br />
                    Lines are open Monday-Thursday: {standardHours}, Friday: {fridayHours}.</p>
            </span>
        </div>
    );
};